import { Component, ojs, app, v } from "modular-openscriptjs";
import {
	pageInfo,
	scrollToTop,
	showActionButton,
	redirect,
	either,
	empty,
} from "../../../helpers";
import { PAGES, uc } from "../../../declarations";
import DeliveryAddress from "../../DeliveryAddress";
import LogisticsCompany from "../../LogisticsCompany";
import SolidIcon from "../../Blocks/SolidIcon";

const h = app("h");
const route = app("router");

ojs(DeliveryAddress, LogisticsCompany, SolidIcon);

export default class OrderDeliveryFee extends Component {
	callbackId;

	render(...args) {
		pageInfo(PAGES.CHECKOUT);
		scrollToTop();

		return h.div(
			{ class: "checkout-page py-4 py-md-5" },

			h.div(
				{ class: "container" },
				h.div(
					{ class: "row justify-content-center" },
					h.div(
						{ class: "col-12 col-md-10 col-lg-8" },

						// Header
						h.div(
							{ class: "mb-4" },
							h.h4({ class: "fw-bold mb-2" }, "Delivery Details"),
							h.p(
								{ class: "text-muted" },
								"Where should we send your order?"
							)
						),

						// Delivery Address Section
						h.div(
							{ class: "mb-4" },
							h.h5(
								{
									class: "text-start mb-3 fw-medium text-dark",
								},
								"1. Delivered To"
							),
							h.DeliveryAddress(uc.addresses, { class: "mb-4" })
						),

						// Logistics Company Section
						v(uc.addresses, (addresses) => {
							return either(!empty(addresses.value), () => [
								h.div(
									{ class: "mb-4" },
									h.h5(
										{
											class: "text-start mb-3 fw-medium text-dark",
										},
										"2. Delivery Method"
									),
									h.LogisticsCompany(uc.addresses, {
										class: "mb-4",
									})
								),
							]);
						})
					)
				)
			),

			...args
		);
	}

	$_rendered_rerendered(...args) {
		if (empty(uc.logisticsCompany.value)) {
			return;
		}

		this.showFinalizeOrderBtn();
	}

	showFinalizeOrderBtn() {
		setTimeout(() => {
			let ele = h.span(
				{
					class: "d-flex align-items-center justify-content-between gap-2",
				},
				h.span(
					{ class: "d-flex gap-2 align-items-center" },
					h.SolidIcon("flag-checkered"),
					h.span("Next")
				),
				h.i({ class: "fas fa-arrow-right" })
			);

			showActionButton((Action, callbackId) => {
				redirect().to("orders.place");
			}, ele.outerHTML);
		}, 500);
	}

	$$logisticsCompany = {
		is: {
			selected: () => {
				if (!route.is("orders.select-address")) return;
				this.showFinalizeOrderBtn();
			},
		},
	};
}

ojs(OrderDeliveryFee);
